import React, { useState } from 'react'
import * as styles from './CredentialsForm.css'
import { Link } from 'react-router-dom'
import { BLUELEAF_LOGO_WHITE } from '../SharedConstants/Images'
require('dotenv').config()

export default function CredentialsForm ({ authenticate }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    authenticate(email, password)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.decorativeCircleTop}></div>
      <div className={styles.decorativeCircleBottom}></div>

      <div className={styles.mainContent}>
        <div className={styles.formWrapper}>
          <div className={styles.logoContainer}>
            <img
              alt="Blueleaf"
              src={BLUELEAF_LOGO_WHITE}
              className={styles.logo}
            />
          </div>
          <div className={styles.formCard}>
            <div className={styles.formHeader}>
              <h2 className={styles.title}>Sign In</h2>
              <p className={styles.subtitle}>Welcome back!</p>
            </div>
            <form id="login-form" onSubmit={handleSubmit}>
              <div className={styles.fieldGroup}>
                <label className={styles.label}>Email Address</label>
                <input
                  className={styles.input}
                  placeholder="you@example.com"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className={styles.fieldGroupPassword}>
                <label className={styles.label}>Password</label>
                <div className={styles.passwordContainer}>
                  <input
                    className={styles.passwordInput}
                    placeholder="Enter your password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className={styles.passwordToggle}
                  >
                    {showPassword
                      ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                        )
                      : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"></path>
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                      </svg>
                        )}
                  </button>
                </div>
              </div>
              <div className={styles.forgotPasswordContainer}>
                <Link to="/forgot_password" className={styles.forgotPasswordLink}>
                  Forgot your password?
                </Link>
              </div>
              <button
                type="submit"
                className={styles.submitButton}
              >
                Sign In
              </button>
            </form>
          </div>
          <div className={styles.supportContainer}>
            <span className={styles.supportText}>
              Need help? <a href="mailto:vipsupport@blueleaf.com" className={styles.supportLink}>
                Contact support
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <p className={styles.footerText}>
          © 2010–2026 Blueleaf Wealth, Inc. All rights reserved. Patent pending.
        </p>
      </div>
    </div>
  )
}
